module.exports = __webpack_public_path__ + "static/media/canvas_thumbnail.5174f386.svg";